import type { EventContentObjectDetail, ProgramInviteType } from 'models';
import type { CommonFormValues } from '../event-form-modal';
import { DefaultEventForm } from './default-event-form';

export type QuickInviteFormData = {
  formValues: QuickInviteFormValues;
};

export type QuickInviteFormValues = CommonFormValues;

type P = {
  eventContentObject: EventContentObjectDetail;
  inviteType: ProgramInviteType;
  isUpdating: boolean;
  onBack: () => void;
  onInviteesTypeChanged: (type: ProgramInviteType) => void;
  onSubmit: (data: QuickInviteFormData) => void;
};

const QuickInviteForm = ({ eventContentObject, ...rest }: P) => (
  <DefaultEventForm eventContentObject={eventContentObject} {...rest} />
);

export default QuickInviteForm;
